import React, { useState } from "react";
import lemon from "../../assets/images/lemon/IMG_6245.jpg";
import logo from "../../assets/images/lemon/371776777_242200888790517_936034044549931900_n.jpg";
import terms from "../../assets/images/lemon/IMG_6246.jpg";
import "./index.css";
const HomePage = () => {
  const [language, SetLanguage] = useState(false);
  const toggleLanguage = () => {
    SetLanguage((prev) => !prev);
  };
  return (
    <main>
      <header className="flex justify-between items-center lg:px-20 px-10 bg-[#F0D99D] py-4">
        <div>
          <img src={logo} className="md:w-20 w-14 rounded-full" alt="" />
        </div>
        <div className="flex gap-5">
          <button
            onClick={toggleLanguage}
            className="text-[#949868] border-b-2 border-[#949868] titlefont"
          >
            {language ? "English" : "Myanmar"}
          </button>
        </div>
      </header>
      <div className=" md:min-h-screen mb-10 pt-14 md:pt-10 text-[#949868]  gap-10 relative bg-lemonBaby_Banner_Mobile md:bg-lemonBaby_Banner bg-no-repeat bg-cover  flex flex-col md:flex-row justify-between items-center lg:px-20 px-10">
        {language ? (
          <div className="md:w-[450px] w-[350px] titlefont">
            <h1 className="lg:text-3xl text-2xl font-semibold  pb-4">
              Lemon Aesthetic Center တွင်
            </h1>
            <p
              className="text-lg pb-4
        "
            >
              (10)သိန်းဖိုးနှင့်အထက် Treatment ယူပါက Cash Back 300,000 Ks ရယူရန်
              ။
            </p>
            <p className="text-lg pb-4">
              Laser Hair Removal (2yrs Unlimited) package ကို 390,000 Ks
              ဖြင့်၀ယ်ယူနိုင်သည့် Gift ရရှိရန် ။
            </p>
          </div>
        ) : (
          <div className="md:w-[450px] w-[350px] titlefont">
            <h1 className="lg:text-3xl text-2xl font-semibold text-[#949868] pb-4">
              At Lemon Aesthetic Centre:
            </h1>
            <p
              className="text-lg pb-4
    "
            >
              Spend over 10,000,000ks on treatments and receive a Cash Back of
              300,000ks.
            </p>
            <p className="text-lg pb-4">
              Get a Laser Hair Removal (2 years unlimited) package with just
              390,000ks.
            </p>
            <p className="text-lg pb-4">
              So, Don't miss out on this fantastic deal and register now to
              claim your share of the excitement!
            </p>
          </div>
        )}
        <div>
          <img
            src={lemon}
            className=" lg:w-[380px] md:w-[240px] rounded-xl"
            alt=""
          />
        </div>
      </div>
      <div className="">
        <div className="  flex flex-col-reverse md:flex-row gap-20 justify-around items-center lg:px-20 px-10 ">
          <div>
            <img src={terms} className="md:w-[700px] rounded-2xl" alt="" />
          </div>
          {language ? (
            <div className="flex text-[#949868] flex-col gap-4 titlefont">
              <h2 className="lg:text-3xl text-2xl font-semibold text-[#949868]">
                Terms & Conditions
              </h2>
              <p>
                (1) 1,000,000 နှင့်အထက် Treatment ယူမှသာ300,000 Cash Back
                ရမည်ဖြစ်သည် ။
              </p>
              <p>
                (2) Laser Hair Removal (2years Unlimited) Package အား 300,000
                Cash Back အစီအစဥ်တွင် ထည့်သွင်းမည်မဟုတ်ပါ ။
              </p>
              <p>(3) ယခုရရှိထား Gift သည် (31.12.2023)အထိ အကျုံး၀င်သည် ။</p>
            </div>
          ) : (
            <div className="flex text-[#949868] flex-col gap-4 titlefont">
              <h2 className="lg:text-3xl text-2xl font-semibold text-[#949868]">
                Terms & Conditions
              </h2>
              <p>
                (1) You'll receive a 300,000 Cash Back when you take a treatment
                worth 1,000,000 or more.
              </p>
              <p>
                (2) The Laser Hair Removal (2 years Unlimited) Package is not
                eligible for the 300,000 Cash Back offer.
              </p>
              <p>(3)The gift you receive is valid until 31.12.2023.</p>
            </div>
          )}
        </div>
      </div>
      <div className="titlefont bg-lemonBaby_Footer bg-no-repeat bg-cover gap-5 relative h-[300px] flex justify-center flex-col items-center">
        {/* <h2>Register Now!!!</h2> */}
        <a href="" className="px-4 bg-[#F4EFCB] rounded-xl py-2">
          Register Now
        </a>
      </div>
    </main>
  );
};

export default HomePage;
